import axios from 'axios'
import { onFulfilled, onRejected } from './interceptors'

let instance = axios.create({
    baseURL: process.env.VUE_APP_REPORTING_API_URL + '/authenticate'
})

instance.interceptors.response.use(onFulfilled, onRejected)
export default instance

